<div class="status-title">
    <span class="status-circle" ngClass="{{statusClass}}"></span>
    {{statusText}}
</div>

<div *ngIf="+rowData.status === 0">
    <a class="status-link text-link" href="javascript:void(0)" (click)="onResendClick()"
        ngbTooltip="Resend Confirmation Link">Resend</a>
</div>